import React, { useEffect } from "react";
import Modal from "components/modal";
import Image from "components/image";
import ErrorMessage from "components/error-message";
import Input from "components/input";
import { validatePhoneNumber } from "helpers/validations";
import PasswordInput from "components/password-input";
import useSignupWithTags from "hooks/useSignupWithTags";
import handleFormChange from "helpers/handle-form-change";
import ButtonLink from "components/button-link";
import { useCustomer } from "hooks/useStore";
import { trackCatalogSignup } from "analytics";

const initialFormState = {
	email: "",
	phoneNumber: "",
	password: "",
	acceptsMarketing: false,
};

const CatalogModal = ({ data, isOpen, toggle }) => {
	const { image, title, subtitle, recieveUpdatesText, thankYouText, firstButton, secondButton } = data;
	const { isAuthenticated } = useCustomer(["isAuthenticated"]);

	const {
		formState,
		setFormState,
		errors,
		loading,
		formSubmit,
		success,
		resetForm,
		setErrors } = useSignupWithTags({ initialState: initialFormState, tags: ["catalog"], track: trackCatalogSignup });


	useEffect(() => {
		if (!isOpen) resetForm();
	}, [isOpen]);


	return (
		<Modal
			isOpen={isOpen}
			close={toggle}
			className="text-center !w-full md:!max-w-screen-lg"
			headerStyle="absolute right-0"
		>
			<div className="flex flex-col md:flex-row py-12 px-8 md:p-8 gap-8">
				<div className="hidden md:flex w-full md:w-2/5 h-fit">
					<Image image={image} />
				</div>
				{!success && !isAuthenticated ?
					<div className="w-full md:w-3/5 flex flex-col gap-4 text-left">
						<h4>{title}</h4>
						<span>{subtitle}</span>
						{errors?.form && <ErrorMessage message={errors?.form} className="justify-center w-4/5" />}
						<form
							className="flex flex-col gap-2 text-black h-full justify-between"
							onSubmit={formSubmit}
							onChange={(e) => handleFormChange(e, setFormState)}>
							<div className="flex flex-col gap-4">
								<Input
									error={errors?.email} required
									type="email" name="email"
									value={formState.email} placeholder="Email"
								/>
								<PasswordInput
									error={errors?.password}
									hideLabel
									value={formState.password} placeholder="Password"
								/>
								{formState.acceptsMarketing &&
									<Input
										error={errors?.phoneNumber}
										type="tel" name="phoneNumber"
										required
										value={formState.phoneNumber} placeholder="Phone Number"
										onChange={(e) => validatePhoneNumber(e, setErrors)}
									/>}
								<div className="flex items-center gap-4">
									<input
										type="checkbox"
										name="acceptsMarketing"
										defaultChecked={formState.acceptsMarketing}
										className="!w-7" />
									<p>{recieveUpdatesText}</p>
								</div>
							</div>
							<div className="flex flex-col items-center justify-center">
								<button
									disabled={loading}
									type="submit"
									className="py-5 btn-primary w-full my-2">
									Subscribe
								</button>
							</div>

						</form>

					</div>
					:
					<div className="w-full md:w-3/5 items-center flex flex-col self-center">
						<h4 className="mb-6">
							{success && thankYouText}
							{!success && isAuthenticated && "Explore and transform your space with timeless elegance."}
						</h4>
						<div className="mt-4 flex flex-col xs:flex-row gap-4 sm:gap-8">
							<ButtonLink data={firstButton} className={`t-catalog-${firstButton.text}`} />
							<ButtonLink data={secondButton} className={`t-catalog-${secondButton.text}`} />
						</div>
					</div>
				}
			</div>
		</Modal>
	);
};


export default CatalogModal;
